module.exports = Jsw.skinUrl + "/icons/16/plesk/nav-navigation.svg?8fd7ed2dae98ebbed97268ffef8454b1";